'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keymap = _interopDefault(require('../keymap/index.js'));
var index_js = require('../utils/index.js');
var index_js$1 = require('../cursor/index.js');
var prosemirrorTransform = require('prosemirror-transform');
var prosemirrorModel = require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

const listAttrs = {
  indent: {
    default: 0
  },
  dataDiffId: {
    default: null
  }
};

const getListNodeAttrs = (node, extraAttrs) => {
  const {
    indent,
    dataDiffId
  } = node.attrs;
  const attrs = {
    'data-diff-id': dataDiffId || `ct-diff-id-${uuid()}`
  };
  let style = '';
  if (indent) style += `margin-left: ${indent * 20}px;`;
  if (style) attrs.style = style;

  if (extraAttrs) {
    return objectSpread({}, attrs, extraAttrs);
  }

  return attrs;
};

const getItemNodeAttrs = (node, extraAttrs) => {
  const {
    dataListItemDiffId
  } = node.attrs;
  const attrs = {};
  attrs['data-list-item-diff-id'] = dataListItemDiffId || `ct-list-item-diff-id-${uuid()}`;
  const firstChild = node.firstChild;

  if (firstChild && firstChild.type.name === 'heading') {
    if (extraAttrs.class) {
      extraAttrs.class += ` ct-item-level-${firstChild.attrs.level}`;
    } else {
      attrs.class = `ct-item-level-${firstChild.attrs.level}`;
    }
  }

  if (extraAttrs) {
    return objectSpread({}, attrs, extraAttrs);
  }

  return attrs;
};

var schema = {
  nodes: {
    // 任务列表
    task_list: {
      attrs: listAttrs,
      content: '(task_item | list_item)+',
      group: 'block',
      defining: true,
      listRole: true,
      parseDOM: [{
        tag: 'ul[class="ct-task-list"]',
        getAttrs: dom => {
          const dataDiffId = dom.getAttribute('data-diff-id');
          const indent = parseInt(dom.style.marginLeft, 10) / 20 || 0;
          return {
            indent,
            dataDiffId
          };
        }
      }],

      toDOM(node) {
        const attrs = getListNodeAttrs(node, {
          class: 'ct-task-list'
        });
        return ['ul', attrs, 0];
      }

    },
    // 任务列表项
    task_item: {
      attrs: {
        checked: {
          default: false
        },
        level: {
          default: 0
        },
        dataListItemDiffId: {
          default: null
        }
      },
      content: '(paragraph | block)+',
      defining: true,
      parseDOM: [{
        tag: 'li[data-type="task_item"]',

        getAttrs(dom) {
          const dataListItemDiffId = dom.getAttribute('data-list-item-diff-id');
          return {
            checked: dom.classList.contains('ct-task-li-checked'),
            dataListItemDiffId
          };
        }

      }],

      toDOM(node) {
        const attrs = getItemNodeAttrs(node, {
          'data-type': 'task_item',
          class: node.attrs.checked ? 'ct-task-li-checked' : 'ct-task-li'
        });
        return ['li', attrs, 0];
      }

    },
    // 有序列表
    ordered_list: {
      attrs: listAttrs,
      content: '(list_item | task_item)+',
      group: 'block',
      defining: true,
      listRole: true,
      parseDOM: [{
        tag: 'ol',
        getAttrs: dom => {
          const indent = parseInt(dom.style.marginLeft, 10) / 20 || 0;
          const dataDiffId = dom.getAttribute('data-diff-id');
          return {
            indent,
            dataDiffId
          };
        }
      }],

      toDOM(node) {
        const attrs = getListNodeAttrs(node);
        return ['ol', attrs, 0];
      }

    },
    // 无序列表
    bullet_list: {
      attrs: listAttrs,
      content: '(list_item | task_item)+',
      group: 'block',
      defining: true,
      listRole: true,
      parseDOM: [{
        tag: 'ul',
        getAttrs: dom => {
          const indent = parseInt(dom.style.marginLeft, 10) / 20 || 0;
          const dataDiffId = dom.getAttribute('data-diff-id');
          return {
            indent,
            dataDiffId
          };
        }
      }],

      toDOM(node) {
        const attrs = getListNodeAttrs(node);
        return ['ul', attrs, 0];
      }

    },
    // 列表项
    list_item: {
      attrs: {
        level: {
          default: 0
        },
        hidden: {
          default: false
        },
        dataListItemDiffId: {
          default: null
        }
      },
      content: '(paragraph | block)+',
      defining: true,
      parseDOM: [{
        tag: 'li',

        getAttrs(dom) {
          const dataListItemDiffId = dom.getAttribute('data-list-item-diff-id');
          const hidden = dom.classList.contains('ct-hidden-item');
          return {
            hidden,
            dataListItemDiffId
          };
        }

      }],

      toDOM(node) {
        const attrs = getItemNodeAttrs(node, node.attrs.hidden ? {
          class: 'ct-hidden-item'
        } : {});
        return ['li', attrs, 0];
      }

    }
  }
};

function judgeListType(state, listType) {
  if (!state) return false;
  const {
    selection,
    tr
  } = state;

  if (selection.constructor.name === 'CellSelection') {
    let has = false;
    const firstRange = selection.ranges[0];
    const from = firstRange.$from.pos;
    const to = firstRange.$to.pos;
    tr.doc.nodesBetween(from, to, (node, pos, parent) => {
      if (has) return;
      if (node.type === listType) has = true;
    });
    return has;
  }

  return !!index_js.findParentNode(selection.$from.path, node => node.type === listType);
}
function isInList(state) {
  if (!state) return false;
  const {
    $from,
    $to
  } = state.selection;
  const range = $from.blockRange($to);
  if (!range) return false;
  const {
    bullet_list,
    ordered_list,
    task_list
  } = state.schema.nodes;
  const listTypes = [bullet_list, ordered_list, task_list];
  const depth0Node = $from.node(range.depth);
  const depth1Node = $from.node(range.depth - 1);
  const depth1NodeType = depth1Node && depth1Node.type;
  const depth0NodeType = depth0Node && depth0Node.type;
  return listTypes.some(type => type === depth1NodeType || type === depth0NodeType);
} // :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool

function wrapInList(listType, attrs) {
  return function (state, dispatch) {
    const {
      doc,
      tr
    } = state;
    let transaction = tr;
    let selection = state.selection;

    if (selection.$from.depth === 0 && selection.$from.pos === 0) {
      selection = prosemirrorState.TextSelection.create(tr.doc, 1);
      transaction.setSelection(selection);
    }

    selection.ranges.forEach((selRange, i) => {
      let {
        $from,
        $to
      } = transaction.selection.ranges[i];
      let range = $from.blockRange($to);
      let doJoin = false;
      let outerRange = range;
      if (!range) return false;
      const fromParent = $from.parent;
      const toParent = $to.parent;
      const isSelectRange = fromParent !== toParent || fromParent.type.name === 'doc' && toParent.type.name === 'doc';

      if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
        if ($from.index(range.depth - 1) === 0) return false;
        const $insert = doc.resolve(range.start - 2);
        outerRange = new prosemirrorModel.NodeRange($insert, $insert, range.depth);

        if (range.endIndex < range.parent.childCount) {
          range = new prosemirrorModel.NodeRange($from, doc.resolve($to.end(range.depth)), range.depth);
        }

        doJoin = true;
      }

      let wrappers = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);

      if (!wrappers) {
        const parentBlockNode = index_js.findParentNode($from.path, node => node.type && node.type.isBlock);
        const newSelection = prosemirrorState.NodeSelection.create(tr.doc, parentBlockNode.pos);
        $from = newSelection.$from;
        $to = newSelection.$to;
        range = $from.blockRange($to);
        doJoin = false;
        outerRange = range;
        if (!range) return false;

        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
          if ($from.index(range.depth - 1) === 0) return false;
          const $insert = doc.resolve(range.start - 2);
          outerRange = new prosemirrorModel.NodeRange($insert, $insert, range.depth);

          if (range.endIndex < range.parent.childCount) {
            range = new prosemirrorModel.NodeRange($from, doc.resolve($to.end(range.depth)), range.depth);
          }

          doJoin = true;
        }

        wrappers = prosemirrorTransform.findWrapping(outerRange, listType, attrs, range);
        if (!wrappers) return false;
      }

      transaction = doWrapInList(transaction, range, wrappers, doJoin, listType, isSelectRange);
    });
    if (dispatch) dispatch(transaction);
    return true;
  };
}

function doWrapInList(tr, range, wrappers, joinBefore, listType, isSelectRange) {
  const {
    start,
    end
  } = range;
  let content = prosemirrorModel.Fragment.empty;

  for (let i = wrappers.length - 1; i >= 0; i--) {
    let attrs = null;

    if (!isSelectRange && wrappers[i].type === listType) {
      attrs = {
        indent: range.$from.parent.attrs.indent
      };
    }

    content = prosemirrorModel.Fragment.from(wrappers[i].type.create(attrs || wrappers[i].attrs, content));
  }

  tr.step(new prosemirrorTransform.ReplaceAroundStep(start - (joinBefore ? 2 : 0), end, start, end, new prosemirrorModel.Slice(content, 0, 0), wrappers.length, true));
  let found = 0;

  for (let i = 0; i < wrappers.length; i++) {
    if (wrappers[i].type === listType) {
      found = i + 1;
    }
  }

  const splitDepth = wrappers.length - found;
  let splitPos = start + wrappers.length - (joinBefore ? 2 : 0),
      parent = range.parent;
  const childNodes = [];

  for (let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false) {
    const childNode = parent.child(i);
    childNodes.push(childNode);
    if (!first && prosemirrorTransform.canSplit(tr.doc, splitPos, splitDepth)) tr.split(splitPos, splitDepth);
    splitPos += childNode.nodeSize + (first ? 0 : 2 * splitDepth);
  } // 去除序列内容的缩进


  tr.doc.nodesBetween(start, end + childNodes.length * 2 + 2, (node, pos) => {
    if (childNodes.includes(node)) {
      tr.setNodeMarkup(pos, null, objectSpread({}, node.attrs, {
        indent: 0
      }));
    }
  });
  return tr;
} // :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool


function unwrapList(state, dispatch) {
  const {
    tr,
    selection
  } = state;
  const {
    list_item,
    task_item
  } = state.schema.nodes;
  const isCellSelection = selection.constructor.name === 'CellSelection';
  let transaction = tr;
  selection.ranges.forEach((selRange, i) => {
    let {
      $from,
      $to
    } = transaction.selection.ranges[i]; // 表格选区时取内容区域

    if (isCellSelection) {
      const trueSelection = prosemirrorState.TextSelection.create(transaction.doc, $from.pos + 2, $to.pos - 2);
      $from = trueSelection.$from;
      $to = trueSelection.$to;
    }

    const range = $from.blockRange($to, node => node.childCount && (node.firstChild.type === list_item || node.firstChild.type === task_item));
    if (!range) return false;
    const outTransaction = liftOutOfList(transaction, range);
    if (outTransaction) transaction = outTransaction;
  });
  if (dispatch) dispatch(transaction);
  return true;
} // :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool

function sinkListItem(state, dispatch) {
  const {
    tr,
    selection,
    schema
  } = state;
  const {
    list_item,
    task_item
  } = schema.nodes;
  const {
    $from,
    $to
  } = selection;
  const range = $from.blockRange($to, node => node.childCount && (node.firstChild.type === list_item || node.firstChild.type === task_item));
  if (!range) return false;
  const startIndex = range.startIndex;

  if (startIndex === 0) {
    const parentNode = range.parent;
    const indent = parentNode.attrs.indent + 1;
    const rangeFrom = range.$from.pos;
    const rangeTo = range.$to.pos;
    tr.doc.nodesBetween(rangeFrom, rangeTo, (node, pos) => {
      if (node === parentNode) dispatch(tr.setNodeMarkup(pos, node.type, objectSpread({}, node.attrs, {
        indent
      })));
    });
    return true;
  }

  let parentNode = range.parent,
      nodeBefore = parentNode.child(startIndex - 1);
  if (nodeBefore.type !== list_item && nodeBefore.type !== task_item) return true;

  if (dispatch) {
    const nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type === parentNode.type;
    const inner = prosemirrorModel.Fragment.from(nestedBefore ? nodeBefore.type.create() : null);
    const slice = new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(nodeBefore.type.create(null, prosemirrorModel.Fragment.from(parentNode.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
    let before = range.start,
        after = range.end;
    dispatch(tr.step(new prosemirrorTransform.ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)));
  }

  return true;
} // :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool

function liftListItem(state, dispatch) {
  const {
    tr,
    selection,
    schema
  } = state;
  const {
    list_item,
    task_item
  } = schema.nodes;
  const itemTypes = [list_item, task_item];
  const {
    $from,
    $to
  } = selection;
  const range = $from.blockRange($to, node => node.childCount && itemTypes.includes(node.firstChild.type));
  if (!range) return false;
  const rangeParent = range.parent;

  if (range.startIndex === 0 && rangeParent.attrs.indent !== 0) {
    const indent = rangeParent.attrs.indent - 1;
    const rangeFrom = range.$from.pos;
    const rangeTo = range.$to.pos;
    tr.doc.nodesBetween(rangeFrom, rangeTo, (node, pos) => {
      if (node === rangeParent) {
        dispatch(tr.setNodeMarkup(pos, node.type, objectSpread({}, node.attrs, {
          indent
        })));
      }
    });
    return true;
  }

  const itemType = $from.node(range.depth - 1).type;

  if (itemTypes.includes(itemType)) {
    return liftToOuterList(state, dispatch, itemType, range);
  }

  const transaction = liftOutOfList(tr, range);
  return transaction && dispatch(transaction);
} // 将列表项层级提升

function liftToOuterList(state, dispatch, itemType, range) {
  let tr = state.tr,
      end = range.end,
      endOfList = range.$to.end(range.depth);

  if (end < endOfList) {
    tr.step(new prosemirrorTransform.ReplaceAroundStep(end - 1, endOfList, end, endOfList, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
    range = new prosemirrorModel.NodeRange(tr.doc.resolveNoCache(range.$from.pos), tr.doc.resolveNoCache(endOfList), range.depth);
  }

  const rangeParent = range.parent;
  const rangeFrom = range.$from.pos;
  const rangeTo = range.$to.pos;
  let transaction = tr;
  tr.doc.nodesBetween(rangeFrom, rangeTo, (node, pos, parent) => {
    if (parent === rangeParent) {
      transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
    }
  });
  dispatch(transaction.lift(range, prosemirrorTransform.liftTarget(range)));
  return true;
} // 将列表项脱离列表

function liftOutOfList(tr, range) {
  const transaction = tr;
  const list = range.parent;

  for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    transaction.delete(pos - 1, pos + 1);
  }

  let $start = transaction.doc.resolve(range.start),
      item = $start.nodeAfter;
  let atStart = range.startIndex == 0,
      atEnd = range.endIndex == list.childCount;
  let parent = $start.node(-1),
      indexBefore = $start.index(-1);

  if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list)))) {
    return false;
  }

  let start = $start.pos,
      end = start + item.nodeSize;
  const slice = new prosemirrorModel.Slice((atStart ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))).append(atEnd ? prosemirrorModel.Fragment.empty : prosemirrorModel.Fragment.from(list.copy(prosemirrorModel.Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1);
  transaction.step(new prosemirrorTransform.ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, slice, atStart ? 0 : 1));
  return transaction;
} // 将单独列表项脱离列表

function liftOutFirstOfList(state, dispatch, range) {
  const {
    tr,
    schema
  } = state;
  const {
    list_item,
    task_list,
    ordered_list,
    bullet_list
  } = schema.nodes;
  const listTypes = [task_list, ordered_list, bullet_list];
  const list = range.parent;

  for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
    pos -= list.child(i).nodeSize;
    tr.delete(pos - 1, pos + 1);
  }

  const $start = tr.doc.resolve(range.start);
  const item = $start.nodeAfter;
  const itemContent = item.content.content;
  const listContent = list.content.content;
  let newListContent = [];
  const outNodes = [];
  itemContent.forEach(node => {
    if (listTypes.includes(node.type)) {
      newListContent.push(list_item.create({
        hidden: true
      }, prosemirrorModel.Fragment.from(node)));
    } else {
      outNodes.push(node);
    }
  });
  newListContent = newListContent.concat(listContent.slice(1));
  const newList = list.copy(prosemirrorModel.Fragment.from(newListContent));
  const newNodes = [...outNodes, newList];
  const start = range.start;
  const end = start + list.nodeSize;
  tr.replaceWith(start - 1, end - 1, prosemirrorModel.Fragment.from(newNodes));
  dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, start)));
  return true;
}

const getTypes = (listType, schema) => {
  const {
    bullet_list,
    ordered_list,
    task_list,
    list_item,
    task_item
  } = schema.nodes;
  let otherListTypes = [];
  let itemType = list_item;
  let otherItemTypes = [task_item];

  if (listType === bullet_list) {
    otherListTypes = [ordered_list, task_list];
  } else if (listType === ordered_list) {
    otherListTypes = [bullet_list, task_list];
  } else {
    itemType = task_item;
    otherItemTypes = [list_item];
    otherListTypes = [ordered_list, bullet_list];
  }

  return {
    itemType,
    otherListTypes,
    otherItemTypes
  };
}; // :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool


function transformList(listType) {
  return function (state, dispatch) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      itemType,
      otherListTypes,
      otherItemTypes
    } = getTypes(listType, schema);
    const isCellSelection = selection.constructor.name === 'CellSelection';
    let transaction = tr;
    selection.ranges.forEach((selRange, i) => {
      let {
        $from,
        $to
      } = transaction.selection.ranges[i]; // 表格选区时取内容区域

      if (isCellSelection) {
        const trueSelection = prosemirrorState.TextSelection.create(transaction.doc, $from.pos + 2, $to.pos - 2);
        $from = trueSelection.$from;
        $to = trueSelection.$to;
      }

      const node = index_js.findParentNode($from.path, node => otherListTypes.includes(node.type));
      if (!node) return;
      const from = node.pos;
      const to = node.node.nodeSize + from;
      let lastItemPos = null;
      let lastItemNode = null;
      transaction.doc.nodesBetween(from, to, (node, pos) => {
        if (otherListTypes.includes(node.type)) {
          if (pos + 4 > from) {
            transaction = transaction.setNodeMarkup(pos, listType, node.attrs);
          }
        } else if (otherItemTypes.includes(node.type)) {
          if (pos - 2 > from) {
            transaction = transaction.setNodeMarkup(pos, itemType, node.attrs);
          } else {
            lastItemPos = pos;
            lastItemNode = node;
          }
        }
      });
      if (lastItemPos) transaction = transaction.setNodeMarkup(lastItemPos, itemType, lastItemNode.attrs);
    });
    dispatch(transaction);
    return true;
  };
}

function handleBackspace(state, dispatch, view) {
  const {
    tr,
    selection,
    schema
  } = state;
  const {
    list_item,
    task_item
  } = schema.nodes;
  const itemTypes = [list_item, task_item];
  let {
    $cursor,
    $from,
    from,
    $to,
    to
  } = selection; // 虚拟光标处理

  if (selection instanceof index_js$1.GapCursor) {
    try {
      $cursor = tr.doc.resolve(from);
    } catch (error) {
      console.error(error);
    }
  } // 序列后块前光标删除


  if ($cursor && $cursor.parent.type.name === 'doc' && $cursor.nodeBefore && $cursor.nodeBefore.type.name.includes('list') && $cursor.nodeAfter && $cursor.nodeAfter.type.isBlock) {
    const newPos = from - 3;
    dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos)));
    return true;
  } // 光标在行首


  if ($from.parentOffset === 0) {
    const fromNodeParent = $from.node(-1);
    const toNodeParent = $to.node(-1);
    if (!fromNodeParent) return false;

    if ($cursor) {
      const isBeforeTable = $cursor.nodeAfter && $cursor.nodeAfter.type.name === 'table';
      const parentTypeIsInline = $cursor.parent.type.isInline;
      const plus = parentTypeIsInline ? 2 : 1;
      const cursorNodeParent = isBeforeTable ? $cursor.node() : $cursor.node(-plus);
      const cursorNode = parentTypeIsInline ? $cursor.node(-1) : $cursor.node();
      const cursor = from - plus + 1;
      const nodeAfter = $to.nodeAfter; // 光标后相邻节点

      const isDocHead = cursor === plus; // 光标是否在文档头部

      const isLastChild = cursorNodeParent.lastChild === cursorNode;
      const nodePreRow = isDocHead ? null : view.domAtPos(cursor - 2).node; // 光标前一行节点

      const nodePreRowName = nodePreRow && nodePreRow.nodeName.toUpperCase(); // 不在序列中，在序列之后

      if (nodePreRowName === 'UL' || nodePreRowName === 'OL') {
        if (!itemTypes.includes(cursorNodeParent.type)) {
          let indent = 3 + plus;
          let parent = nodePreRow;
          let nodeName;

          while (true) {
            const lastChild = parent.lastElementChild.lastElementChild;
            nodeName = lastChild.nodeName.toUpperCase();

            if (nodeName !== 'UL' && nodeName !== 'OL') {
              break;
            }

            parent = lastChild;
            indent += 2;
          } // 序列项中的非文本内容后删除


          if (nodeName !== 'P' && nodeName[0] !== 'h') {
            indent -= 1;
          }

          const newPos = cursor - indent;

          if (!nodeAfter) {
            tr.delete(cursor - 1, to + 1);
            tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
          } else {
            const cursorNodeSize = cursorNode.nodeSize;

            if (isLastChild) {
              tr.delete(cursor, cursor + cursorNodeSize - 1);
            } else {
              tr.delete(cursor, cursor + cursorNodeSize);
            }

            if (cursorNode.content.childCount) {
              tr.insert(newPos, cursorNode.content);
              tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
            } else {
              tr.insert(newPos, cursorNode);
              tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos + 1));
            }
          }

          dispatch(tr);
          return true;
        } else if (cursorNode === cursorNodeParent.content.content[0]) {
          const range = $cursor.blockRange($cursor, node => node.childCount && node.firstChild.type === cursorNodeParent.type);
          if (!range) return false;
          const rangeParent = range.parent;
          const content = rangeParent.content.content;

          if (content[0] !== cursorNodeParent) {
            const newList = rangeParent.copy(prosemirrorModel.Fragment.from(content.filter(n => n !== cursorNodeParent)));
            const start = $cursor.path[$cursor.path.length - (parentTypeIsInline ? 13 : 10)];
            const end = start + rangeParent.nodeSize;
            tr.replaceWith(start, end, newList);
            tr.insert(cursor - 3, prosemirrorModel.Fragment.from(cursorNodeParent.content));
            dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, cursor - 2)));
            return true;
          }

          if (content.length === 1) {
            const transaction = liftOutOfList(tr, range);
            return transaction && dispatch(transaction);
          }

          return liftOutFirstOfList(state, dispatch, range);
        }
      } else if (nodePreRowName === 'LI' && isBeforeTable) {
        const range = $cursor.blockRange($cursor, node => node.childCount && node.firstChild.type === cursorNodeParent.type);
        if (!range) return false;
        const rangeParent = range.parent;
        const content = rangeParent.content.content;

        if (content[0] !== cursorNodeParent) {
          const newList = rangeParent.copy(prosemirrorModel.Fragment.from(content.filter(n => n !== cursorNodeParent)));
          const start = $cursor.path[$cursor.path.length - 2];
          const end = start + rangeParent.nodeSize;
          tr.replaceWith(start, end, newList);
          tr.insert(cursor - 3, prosemirrorModel.Fragment.from(cursorNodeParent.content));
          dispatch(tr.setSelection(new index_js$1.GapCursor(tr.doc.resolve(cursor - 2))));
          return true;
        }
      }

      return false; // 跨级删除序列问题
    } else if ($to.parentOffset === $to.node().content.size && fromNodeParent !== toNodeParent && fromNodeParent && itemTypes.includes(fromNodeParent.type) && toNodeParent && itemTypes.includes(toNodeParent.type)) {
      tr.delete(from, to);
      dispatch(tr);
      return true;
    }
  } // 跨节点删除序列不全


  const foundFromNode = index_js.findParentNode($from.path, n => n.type && n.type.spec.listRole);
  const foundToNode = index_js.findParentNode($to.path, n => n.type && n.type.spec.listRole);

  if (foundToNode && (!foundFromNode || foundFromNode.node !== foundToNode.node) && to === foundToNode.pos + foundToNode.node.nodeSize - 3) {
    tr.delete(from, to + 3);
    dispatch(tr);
    return true;
  }

  return false;
} // 向后删除动作处理

function handleDelete(state, dispatch) {
  const {
    tr,
    selection,
    schema
  } = state;
  const {
    $cursor,
    $from,
    from,
    $to,
    to
  } = selection;
  const {
    list_item,
    task_item
  } = schema.nodes;
  const itemTypes = [list_item, task_item];
  const toNode = $to.node(); // 光标在行首

  if ($from.parentOffset === 0) {
    const fromNodeParent = $from.node(-1);
    const toNodeParent = $to.node(-1);
    if (!fromNodeParent) return false;

    if (!$cursor && $to.parentOffset === toNode.content.size && fromNodeParent !== toNodeParent && fromNodeParent && itemTypes.includes(fromNodeParent.type) && toNodeParent && itemTypes.includes(toNodeParent.type)) {
      tr.delete(from, to);
      dispatch(tr);
      return true;
    }
  }

  return false;
}
function handleEnter(state, dispatch) {
  const {
    paragraph,
    heading,
    list_item,
    task_item
  } = state.schema.nodes;
  const itemTypes = [list_item, task_item];
  const tr = state.tr;
  let selection = state.selection; // 光标在inline节点末尾（如链接）

  const $anchor = selection.$anchor;

  if (!$anchor.parent.type.isBlock && !$anchor.nodeAfter) {
    const node = index_js.findParentNode($anchor.path, n => [paragraph, heading].includes(n.type));
    if (!node) return false;
    const pos = node.pos + node.node.nodeSize - 1;
    selection = prosemirrorState.TextSelection.create(state.doc, pos);
    tr.setSelection(selection);
  }

  const {
    $from,
    $to,
    node,
    from
  } = selection;
  const fromNode = $from.node();
  if (!index_js.canInsertTypes(state)) return false;
  if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
  const grandParent = $from.node(-1);
  if (!itemTypes.includes(grandParent.type) && !itemTypes.includes(fromNode.type)) return false; // 列表项首个子节点为空

  if ($from.parent === grandParent.content.content[0] && $from.parent.content.size === 0) {
    const range = $from.blockRange($to, n => n.childCount && n.firstChild.type === grandParent.type);
    if (!range) return false;

    if (dispatch) {
      const itemType = $from.node(range.depth - 1).type;

      if (itemTypes.includes(itemType)) {
        return liftToOuterList(state, dispatch, itemType, range);
      }

      const transaction = liftOutOfList(tr, range);
      transaction && dispatch(transaction);
      return !!transaction;
    }

    return true;
  }

  const nextType = $to.pos === $from.end() ? grandParent.defaultContentType(0) : null;
  tr.delete($from.pos, $to.pos);
  const types = nextType && [null, {
    type: nextType,
    attrs: objectSpread({}, $from.node().attrs)
  }];
  if (!prosemirrorTransform.canSplit(tr.doc, $from.pos, 2, types)) return false;
  const marks = state.storedMarks || $to.parentOffset && $from.marks() || [];

  if (dispatch) {
    const atStart = $to.parentOffset === 0;

    if (atStart) {
      tr.insert(from, grandParent.type.createAndFill({
        dataListItemDiffId: `ct-list-item-diff-id-${uuid()}`
      }));
      tr.deleteRange(from, from + 2);
      dispatch(tr.scrollIntoView());
      return true;
    } // 任务列表特殊处理


    if (grandParent.type === task_item) {
      const pos = index_js.findParentNode($from.path, n => n.type === task_item).pos;
      tr.setNodeMarkup(pos, null, objectSpread({}, grandParent.attrs, {
        checked: false,
        dataListItemDiffId: `ct-list-item-diff-id-${uuid()}`
      }));
      tr.split($from.pos, 2, types);
      tr.setNodeMarkup(pos, null, objectSpread({}, grandParent.attrs));
    } else {
      tr.split(tr.mapping.map($from.pos), 2, [{
        type: list_item,
        attrs: {
          dataDiffId: `ct-list-item-diff-id-${uuid()}`
        }
      }, {
        type: paragraph,
        attrs: {
          dataDiffId: `ct-diff-id-${uuid()}`
        }
      }]);
    }

    dispatch(tr.ensureMarks(marks).scrollIntoView());
  }

  return true;
}

const handleClick = (view, pos, e) => {
  if (e.target.getAttribute('data-type') !== 'task_item') return false;
  const {
    state,
    dispatch
  } = view;
  const {
    tr,
    schema
  } = state;
  let selection;

  try {
    selection = prosemirrorState.NodeSelection.create(state.doc, pos);
  } catch (e) {
    return false;
  }

  const node = selection.node;

  if (node.type === schema.nodes.task_item) {
    const attrs = node.attrs;
    dispatch(tr.setNodeMarkup(pos, null, objectSpread({}, attrs, {
      checked: !attrs.checked
    })));
  }

  return false;
};

const pluginKey = new prosemirrorState.PluginKey('list');
function createPlugin(store) {
  return new prosemirrorState.Plugin({
    key: pluginKey,
    props: {
      handleClick,
      handleDoubleClick: handleClick,
      transformPasted: slice => {
        const {
          state
        } = store.view;
        const {
          schema,
          selection
        } = state;
        const {
          ordered_list,
          bullet_list,
          task_list,
          list_item,
          task_item
        } = schema.nodes;
        const listTypes = [ordered_list, bullet_list, task_list];
        const {
          $cursor
        } = selection;
        const sliceContent = slice.content.content; // 序列复制到序列内处理

        if ($cursor && sliceContent.length === 1) {
          const sliceNode = sliceContent[0];
          const {
            nodeBefore,
            nodeAfter,
            path
          } = $cursor;
          const listNode = path[path.length - 9];

          if (!nodeBefore && !nodeAfter && listTypes.includes(sliceNode.type) && listNode && listTypes.includes(listNode.type) && sliceNode.type !== listNode.type) {
            sliceContent[0] = listNode.type.create(sliceNode.attrs, sliceNode.content);
          }
        } // 序列与序列项匹配


        sliceContent.forEach(node => {
          if (node.type === ordered_list || node.type === bullet_list) {
            const items = node.content.content;
            items.forEach((item, i) => {
              if (item.type === task_item) {
                items[i] = list_item.create(item.attrs, item.content);
              }
            });
          } else if (node.type === task_list) {
            const items = node.content.content;
            items.forEach((item, i) => {
              if (item.type === list_item) {
                items[i] = task_item.create(item.attrs, item.content);
              }
            });
          }
        });
        return slice;
      }
    }
  });
}

class ListStore {
  constructor() {
    this.view = null;
    this.modules = {};
  }

  init(moduleManager) {
    this.view = moduleManager.view;
    this.modules = moduleManager.modules;
  }

}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".pm-body-wrapper ol,.pm-body-wrapper ul,.ProseMirror ol,.ProseMirror ul{margin:8px 0;padding-left:24px}.pm-body-wrapper ol li,.pm-body-wrapper ul li,.ProseMirror ol li,.ProseMirror ul li{min-height:24px;font-size:14px}.pm-body-wrapper ol>h1,.pm-body-wrapper ol>h2,.pm-body-wrapper ol>h3,.pm-body-wrapper ol>h4,.pm-body-wrapper ol>h5,.pm-body-wrapper ol>h6,.pm-body-wrapper ol>p,.pm-body-wrapper ul>h1,.pm-body-wrapper ul>h2,.pm-body-wrapper ul>h3,.pm-body-wrapper ul>h4,.pm-body-wrapper ul>h5,.pm-body-wrapper ul>h6,.pm-body-wrapper ul>p,.ProseMirror ol>h1,.ProseMirror ol>h2,.ProseMirror ol>h3,.ProseMirror ol>h4,.ProseMirror ol>h5,.ProseMirror ol>h6,.ProseMirror ol>p,.ProseMirror ul>h1,.ProseMirror ul>h2,.ProseMirror ul>h3,.ProseMirror ul>h4,.ProseMirror ul>h5,.ProseMirror ul>h6,.ProseMirror ul>p{margin:0}.pm-body-wrapper ol .ct-image,.pm-body-wrapper ul .ct-image,.ProseMirror ol .ct-image,.ProseMirror ul .ct-image{vertical-align:top}.pm-body-wrapper ol hr,.pm-body-wrapper ul hr,.ProseMirror ol hr,.ProseMirror ul hr{display:inline-block}.pm-body-wrapper .ct-item-level-1,.ProseMirror .ct-item-level-1{font-size:28px}.pm-body-wrapper .ct-item-level-2,.ProseMirror .ct-item-level-2{font-size:24px}.pm-body-wrapper .ct-item-level-3,.ProseMirror .ct-item-level-3{font-size:20px}.pm-body-wrapper .ct-item-level-4,.ProseMirror .ct-item-level-4{font-size:16px}.pm-body-wrapper .ct-item-level-5,.ProseMirror .ct-item-level-5{font-size:14px}.pm-body-wrapper .ct-item-level-6,.ProseMirror .ct-item-level-6{font-size:12px}ol .ct-item-level-1{margin-left:12px}ol .ct-item-level-2{margin-left:8px}ol .ct-item-level-3{margin-left:5px}ol .ct-item-level-4{margin-left:1px}ol .ct-item-level-6{margin-left:-2px}ul .ct-item-level-1{margin-left:7px}ul .ct-item-level-2{margin-left:6px}ul .ct-item-level-3{margin-left:3px}ul .ct-item-level-4{margin-left:2px}ul .ct-item-level-6{margin-left:-1px}.ct-task-list{list-style-type:none!important}.ct-task-list li{margin-left:0}.ct-task-list .ct-task-li{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li:before{content:\"\";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h16v16H0V0zm1 1v14h14V1H1z' fill='%236E6B6B' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.ct-task-list .ct-task-li-checked{position:relative;list-style-type:none!important}.ct-task-list .ct-task-li-checked:before{content:\"\";position:absolute;top:3px;left:-21px;height:17px;width:17px;border-radius:1px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0v1H1v14h14V7h1v9H0V0h12zM6.908 9.728l7.385-7.385a1 1 0 0 1 1.414 1.414l-8.071 8.071c-.2.201-.465.299-.728.293a.997.997 0 0 1-.728-.293L2.938 8.586a1 1 0 0 1 1.414-1.414l2.556 2.556z' fill='%23AAA' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.ct-task-li-checked:after,.ct-task-li-checked:before,.ct-task-li:before{cursor:pointer}.ct-task-list .ct-item-level-1:before{top:15px}.ct-task-list .ct-item-level-2:before{top:12px}.ct-task-list .ct-item-level-3:before{top:8px}.ct-task-list .ct-item-level-4:before{top:5px}.ct-task-list .ct-item-level-6:before{top:1px}li.ProseMirror-selectednode,li.ProseMirror-selectednode:after{display:none}.ct-task-list .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked div,.ct-task-list .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked p,.ct-task-list .ct-task-li-checked span,.ct-task-list .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked video{opacity:.7}.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li audio,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li div,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h1,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h2,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h3,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h4,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h5,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li h6,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li p,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li span,.ct-task-list .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li .ct-task-li-checked .ct-task-li video{opacity:unset}ol{list-style-type:decimal}ol ol{list-style-type:lower-alpha}ol ol ol{list-style-type:lower-roman}ol ol ol ol{list-style-type:decimal}ol ol ol ol ol{list-style-type:lower-alpha}ol ol ol ol ol ol{list-style-type:lower-roman}ol ol ol ol ol ol ol{list-style-type:decimal}ol ol ol ol ol ol ol ol{list-style-type:lower-alpha}ol ol ol ol ol ol ol ol ol{list-style-type:lower-roman}ul{list-style-type:disc}ul ul{list-style-type:square}ul ul ul{list-style-type:circle}ul ul ul ul{list-style-type:disc}ul ul ul ul ul{list-style-type:square}ul ul ul ul ul ul{list-style-type:circle}ul ul ul ul ul ul ul{list-style-type:disc}ul ul ul ul ul ul ul ul{list-style-type:square}ul ul ul ul ul ul ul ul ul{list-style-type:circle}.ct-hidden-item{list-style:none}";
styleInject(css);

class ListModule {
  constructor() {
    this.name = 'list';
    this.store = new ListStore();
    this.schema = schema;
    this.commands = {
      wrapInList,
      unwrapList: () => unwrapList,
      transformList,
      liftListItem: () => liftListItem,
      sinkListItem: () => sinkListItem
    };
    this.utils = {
      judgeListType,
      isInList
    };
    this.plugins = [keymap({
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      Delete: handleDelete,
      'Mod-Delete': handleDelete,
      Enter: handleEnter
    }), createPlugin(this.store)];
    this.pluginPriority = 'high';
  }

  init(moduleManager) {
    this.store.init(moduleManager);
  }

}
ListModule.moduleName = 'list';

exports.ListModule = ListModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/list/index.js